import React, { useEffect, useMemo, useState } from "react";
import "./AvatarImage.scss";

function getInitial(name) {
  const text = String(name || "").trim();
  if (!text) return "?";
  return text.charAt(0).toUpperCase();
}

export default function AvatarImage({
  src,
  alt = "",
  name = "",
  className = "",
  fallbackClassName = "",
  title = "",
}) {
  const [hasError, setHasError] = useState(false);
  const safeSrc = String(src || "").trim();

  useEffect(() => {
    setHasError(false);
  }, [safeSrc]);

  const finalTitle = title || name || alt || "Avatar";
  const initial = useMemo(() => getInitial(name || alt), [name, alt]);

  if (!safeSrc || hasError) {
    return (
      <span
        className={`${fallbackClassName || className} hb_avatar_fallback`.trim()}
        title={finalTitle}
        aria-label={finalTitle}
      >
        {initial}
      </span>
    );
  }

  return (
    <img
      src={safeSrc}
      alt={alt}
      className={className}
      title={finalTitle}
      onError={() => setHasError(true)}
    />
  );
}
